"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinFieldPath = void 0;
const joinFieldPath = (base, ext) => {
    if (base && ext) {
        return base + "." + ext;
    }
    else {
        return base || ext || "";
    }
};
exports.joinFieldPath = joinFieldPath;
